.root {
  flex: 0 0 auto;
  border: 1px solid var(--color-lines-translucent);
  border-radius: 8px;
  overflow: hidden;
  margin-top: 10px;
  background: var(--color-secondary-bg);
}

.heading {
  border-bottom: 1px solid var(--color-accent-lines);
  font-size: 12px;
  text-transform: uppercase;
  padding: 10px 12px;

  a {
    color: var(--color-text-secondary);
    text-decoration: none;
  }
}

.tabs {
  display: flex;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--color-accent-lines);
  background: var(--color-bg);
}

.tab {
  appearance: none;
  border: 0;
  border-radius: 999px;
  background: var(--color-accent-bg);
  color: var(--color-accent-fg);
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  padding: 6px 10px;
  cursor: pointer;

  &[data-active='true'] {
    background: var(--color-accent);
    color: var(--color-accent-fg);
  }

  &:focus-visible {
    outline: 2px solid var(--color-accent-lines);
    outline-offset: 1px;
  }
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.item + .item {
  border-top: 1px solid var(--color-accent-lines);
}

.itemLink {
  display: block;
  color: inherit;
  text-decoration: none;
  padding: 10px 12px;

  &:focus-visible {
    outline: 0;
    background: var(--color-accent);
  }
}

.meta {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
  color: var(--color-content-fg);
  font-size: 12px;
}

.preview {
  margin: 0;
  color: var(--color-content-fg);
  font-size: 14px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
}

.empty {
  padding: 12px;
  color: var(--color-content-fg);
  font-size: 13px;
}
